module.exports = __webpack_public_path__ + "images/emails/digest/bg-clipboard-8bb27bf1.png";